import React, { useEffect, useState } from "react";
import PlusIcon from "assets/icon/PlusIcon";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, PageSize, PaginationBack, PaginationFirst, PaginationLast, PaginationNext, SalesStockStatusOptions, StatusCodeActive } from "utils/Constant";
import { ApiGetBrandList, ApiGetSalesStockList, ApiDeleteSalesStock, ApiGetUserList, ApiDeleteUser } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import Dropdown from "components/Input/Dropdown";
import { GetStatus, money } from "utils/helpers"
import RevisionIcon from "assets/icon/RevisionIcon";
import { useModal } from "components/modal/ModalContext";
import Select from 'react-select'

export default function CustomerLogin(){
    let navigate = useNavigate()
    const {openModal, closeModal} = useModal()

    const { fetch: apiGetBrandList, data: brandList } = useFetch(ApiGetBrandList)
    const { fetch: apiGetSalesStockList, data: salesStockList } = useFetch(ApiGetSalesStockList)
    const { fetch: apiDeleteSalesStock } = useFetch(ApiDeleteSalesStock)
    const { fetch: apiGetUserList, data: userList } = useFetch(ApiGetUserList)
    const { fetch: apiDeleteUser } = useFetch(ApiDeleteUser)


    const [username, setUsername] = useState('')
    const [name, setName] = useState('')
    const [productName, setProductName] = useState('')

    const [stockCode, setStockCode] = useState('')
    const [stockStatus, setStockStatus] = useState(SalesStockStatusOptions[0].value)
    const [brandOptions, setBrandOptions] = useState('')
    const [brand, setBrand] = useState('')
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [firstLoad, setFirstLaod] = useState(true)

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Button Event
    const addBtnClick = () => {
        navigate("/customer-login/form?customerLoginId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (id) => {
        navigate("/customer-login/form?customerLoginId=" + id + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = (id, status) => {
        openModal(ModalTypeConfirmation, {
            onConfirm: () => {
                openModal(ModalTypeLoading)

                deleteUser(id, status).then((res) => {
                    if (checkResponse(res)) {
                        fBindGrid(pageIndex)
                        closeModal()
                    }                    
                })
            },
        })
    }

    // API Calls
    const getUserList = async(index) => {
        let res = await apiGetUserList({
            data: {
                username,
                name,
                status,
                pageSize: PageSize,
                pageIndex: parseInt(index)
            }
        })

        return res
    }

    const getSalesStockList = async(index) => {
        let res = await apiGetSalesStockList({
            data: {
                productName, 
                brandId: brand === null || brand === '' ? '' : brand.value,
                stockCode,
                stockStatus,
                status,
                pageSize: PageSize,
                pageIndex: parseInt(index)
            }
        })

        return res
    }
    const getBrandList = async(index) => {
        let res = await apiGetBrandList({
            data: {
                brandName: '', 
                status: '1',
                pageSize: 1000,
                pageIndex: 0
            }
        })

        return res
    }
    const deleteSalesStock = async(salesStockId, status) => {
        let res

        res = await apiDeleteSalesStock({
            data: {
                salesStockId,
                status
            }
        })

        return res
    }
    const deleteUser = async(userId, status) => {
        let res = await apiDeleteUser({
            data: {
                userId,
                status
            }
        })

        return res
    }

    // Function Grid
    async function fBindGrid(index){
        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        getUserList(i).then((res) => {
            if (checkResponse(res)) {
                if (res !== null){
                    let totalData = res.data.totalData
                    fSetPaginationOptions(totalData, index)
                }
                
                closeModal()
            }
        })   
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    const checkResponse = (response) => {
        if(response.status === ApiResponseSuccess){
            return true
        }else if(response.status === ApiResponseStatusUnauthorized){
            window.location.href = "/login"
        }else{
            openModal(ModalTypeFail, { message: response.message })
            return false
        }
    }

    useEffect(() => {
        fBindGrid(0)
        // if (firstLoad) {
        //     openModal(ModalTypeLoading)
        // }

        // getBrandList().then((res) => {
        //     if (checkResponse(res)) {
        //         let data = res?.data?.listData
        //         let tempData = [{ label: 'All', value: '' }]

        //         data.map((data, i) => tempData.push({ label: data.brandName, value: String(data.brandId)}))

        //         setBrandOptions(tempData)
        //     }
        // }).finally(() => {
        //     fBindGrid(0)
        //     setFirstLaod(false)
        // })
    },[brand, productName, stockStatus, status])

    return(
        <div className="flex flex-col gap-2 p-2 sm:p-6">
            <div >
                <span className="font-semibold text-2xl">Customer Login</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <div className="flex flex-col gap-1 w-full sm:w-[280px]">
                        <span>Username</span>
                        <input className="input" value={username} onChange={(e) => { setUsername(e.target.value) }} />
                    </div>
                    <div className="flex flex-col gap-1 w-full sm:w-[120px]">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder='All' />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-between bg-white p-2 rounded-xl shadow-md">
                <div className="flex gap-2">
                    { SalesStockStatusOptions.map((data, i) => { return (
                        <div className={`border px-3 flex items-center rounded-lg cursor-pointer ${stockStatus === data.value ? 'bg-black text-white' : ''} `}
                            onClick={() => { setStockStatus(data.value) }}
                        >
                            {data.label}
                        </div>
                    )})}
                </div>
                <button className="button flex gap-2" onClick={addBtnClick}>
                    <PlusIcon />
                    <span>Add</span>
                </button>
            </div>
           
            <div className="mt-2 overflow-hidden sm:border sm:rounded-3xl sm:shadow-sm">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Username</th>
                            <th className="font-semibold text-left px-2">Name</th>
                            <th className="font-semibold text-left px-2">Client</th>
                            <th className="font-semibold text-left px-2">Status</th>
                            <th className="font-semibold w-auto sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        { userList?.data?.listData?.length === 0 && (
                            <tr className="text-center h-12">
                               <td colSpan={8}>No Data Available</td> 
                            </tr>
                        )}
                        { userList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.username }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.fullName }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.companyName }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="button gap-2 flex" onClick={() => editBtnClick(data.userId)}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2`} onClick={() => deleteBtnClick(data.userId, data.status)}>
                                            {data.status === StatusCodeActive ? (<TrashIcon className="w-4 fill-white" />) : (<RevisionIcon className="w-4 fill-white" />)}
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />
        </div>
    )
}